/* eslint-disable max-len,jsx-a11y/anchor-is-valid */

import PropTypes from 'prop-types'
import Infowijs from './Infowijs'
import { ThreeLines } from '../icons'

function TopBar({ onNavigationOpen }) {
  return (
    <div className="w-full fixed top-0 flex flex-col flex-1 overflow-hidden">
      <div className="lg:hidden">
        <div className="flex items-center justify-between bg-white border-b border-gray-200 pl-6 pr-4 py-2">
          <Infowijs />
          <button
            type="button"
            className="p-2 items-center justify-center text-gray-500 hover:text-gray-900"
            onClick={onNavigationOpen}
          >
            <span className="sr-only">Open sidebar</span>
            <ThreeLines className="text-[1.5rem]" />
          </button>
        </div>
      </div>
    </div>
  )
}

TopBar.propTypes = {
  onNavigationOpen: PropTypes.func,
}

TopBar.defaultProps = {
  onNavigationOpen: null,
}

export default TopBar
